// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Franquias_SetAtivoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Input de /franquias/setAtivo (chamado 2026-0023).
 *
 * Status e VISIBILIDADE NA GESTAO, nao permissao. Desativar uma franquia nao tira o
 * acesso de ninguem, nao mexe no filtro global e nao mexe no select de franquias —
 * quem cuida de acesso e o vinculo usuario-franquia, noutro lugar. Por isso este
 * input nao tem nada alem do id e do novo estado.
 */
import { registerContract } from './validate'

export interface Franquias_SetAtivoInput {
franquia_id?: number
ativo?: boolean
}

registerContract('Franquias_SetAtivoInput', {
  franquia_id: { type: 'number',  required: false },
  ativo:       { type: 'boolean', required: false },
})
